module.exports = __webpack_public_path__ + "img/swimming.be5030ca.webp";